import { render } from "./Stores.vue?vue&type=template&id=f06aaf60&scoped=true"
import script from "./Stores.vue?vue&type=script&lang=js"
export * from "./Stores.vue?vue&type=script&lang=js"

import "./Stores.vue?vue&type=style&index=0&id=f06aaf60&lang=scss&scoped=true"
import "./Stores.vue?vue&type=style&index=1&id=f06aaf60&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f06aaf60"]])

export default __exports__